



<div>
  <router-outlet></router-outlet>
</div>





<!-- toast -->
<p-toast [position]="lang == 'en' ? 'top-right' : 'top-left'"></p-toast>
